module.exports = __webpack_public_path__ + "img/thumbnail_Capybara_m_normal.a2021818.png";